export default __webpack_public_path__ + "static/media/coventry-light.8c69c570.png";